module.exports = __webpack_public_path__ + "images/emoji/money_with_wings.0ceec64bd220d42b3d52.png";